import { cn } from '../../../utils/string/cn.utils';

const ButtonTertiaryLarge = ({
  title,
  preIcon,
  posIcon,
  type = 'button',
  active = false,
  ...props
}) => {
  return (
    <button
      type={type}
      {...props}
      className={cn(
        'bg-trans hover:bg-primary-primaryFill disabled:cursor-not-allowed disabled:pointer-events-none outline-none border-none inline-flex justify-center items-center cursor-pointer',
        active ? 'bg-primary-primaryFill' : '',
        'text-body-large font-semibold text-primary-primary disabled:text-black-low',
        'h-[40px] py-[10px] px-[16px] gap-[8px] rounded-[8px]',
        props?.className
      )}
      style={{
        ...(props?.style ?? {}),
        ...{
          paddingRight: `${preIcon ? '12px' : undefined}`,
          paddingLeft: `${posIcon ? '12px' : undefined}`,
        },
      }}
    >
      {posIcon && (
        <div className="w-[20px] h-[20px] flex content-center disabled:text-black-low">
          {posIcon}
        </div>
      )}
      <span className="truncate disabled:text-black-low">{title}</span>
      {preIcon && (
        <div className="w-[20px] h-[20px] flex content-center disabled:text-black-low">
          {preIcon}
        </div>
      )}
    </button>
  );
};

export default ButtonTertiaryLarge;
